import "./Footer.css";
import { getTranslatedText as translate } from "../Localization/Translation";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";

function Footer() {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));

  return (
    <div className="Footer-component">
      <div className="footer-links">
        <a
          className="footer-link btn btn-primary btn-start"
          href="https://user-cleaning-service.netlify.app/"
          target="_blank"
        >
          <i className="bi bi-laptop"></i>
          <span>{translate("visit-tab", locale)}</span>
        </a>
        <a
          className="footer-link btn btn-primary btn-start"
          href="https://drive.google.com/file/d/1e2MCFuTs6z5GC6u_IcLX7zc7p5AmoMYE/view?usp=sharing"
          target="_blank"
        >
          <i className="bi bi-download"></i>
          <span>{translate("download-desktop", locale)}</span>
        </a>
        <a
          className="footer-link btn btn-primary btn-start"
          href="https://drive.google.com/drive/u/0/folders/1PyEjNk2ulmkdFn2AUaTjq4WDyYXiF9Sj"
          target="_blank"
        >
          <i className="bi bi-download"></i>
          <span>{translate("download-android", locale)}</span>
        </a>
        <a
          className="footer-link btn btn-primary btn-start"
          href="#"
          target="_blank"
        >
          <i className="bi bi-download"></i>
          <span>{translate("download-iphone", locale)}</span>
        </a>
      </div>
      <div className="Footer">
        <div
          className="footer-container d-flex justify-content-between"
          dir={locale === "AR" ? "rtl" : "ltr"}
        >
          {/* Copy Rights */}
          <div className="footer-hovering">
            {translate("copy-right", locale)}
          </div>

          {/* Social Media Icons */}
          <div
            className="footer-social-media-icons d-flex justify-content-between row"
            dir="rtl"
          >
            <i className="bi bi-facebook col footer-hovering"></i>
            <i className="bi bi-whatsapp col footer-hovering"></i>
            <i className="bi bi-twitter col footer-hovering"></i>
            <i className="bi bi-instagram col footer-hovering"></i>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
